<template>
  <div class="mt-5">

    <div 
      :class="{'d-flex justify-space-between': $vuetify.breakpoint.mdAndUp}"
    >


      <v-card v-for="item in styles" :key="item.factor"
        height="200"
        class="d-block mb-3"
        :class="{'card-width': $vuetify.breakpoint.mdAndUp}"
        :style="'background: linear-gradient(to bottom,' + item.colors[0] + ','+ item.colors[1] + ');'"
      >
        <v-icon class="mt-2 ml-2" style="font-size: 40px; color: #183e77;"> {{item.icon}} </v-icon>
        <div class="text-center" style="color: #183e77;">
          <span class="font-weight-bold" style="vertical-align: 22px; font-size: 15px;">decile</span><span class="display-2 font-weight-bold mr-1">{{item.decile}}</span>
        </div>
        <div class="mt-2 mx-auto text-center">
          <span style="color: #183e77; background: white; border-radius: 5px;" class="font-weight-bold px-5 py-1">
            {{item.classification}}
          </span>
        </div>
        <div class="text-center mt-2">
          <span class="font-weight-bold" style="font-size: 20px; color: #183e77;">
            {{item.factor}}
          </span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon dense medium style="color: #183e77; position: absolute; right: 3px; bottom: 3px;" v-on="on">mdi-alert-circle-outline </v-icon>
            </template>
            <span>{{item.info}}</span>
          </v-tooltip>  
        </div>
      </v-card>



    </div>
  </div>
</template>


<script>
  export default {
    name: 'StockAnalyzeComponentStyles',
    props: {
      stock: {
        type: String,
        required: true
      }
    },   
    data() {
      return {
        listLoad: true,
        errorbar: false,
        styles: [
          {decile: '-', factor: "factor 1", info: "factor", icon: "mdi-search-web", classification: "-", colors : ['#3beed3', '#14e1f2']},
          {decile: '-', factor: "factor 2", info: "factor", icon: "mdi-chart-areaspline", classification: "-", colors : ['#3beed3', '#14e1f2']},
          {decile: '-', factor: "factor 3", info: "factor", icon: "mdi-chart-timeline-variant", classification: "-", colors : ['#3beed3', '#14e1f2']},
          {decile: '-', factor: "factor 4", info: "factor", icon: "mdi-filter-variant", classification: "-", colors : ['#3beed3', '#14e1f2']},
          {decile: '-', factor: "factor 5", info: "factor", icon: "mdi-seal-variant", classification: "-", colors : ['#3beed3', '#14e1f2']}
        ] 
      }
    },
    watch: {
      stock: {
        handler() {
          this.getStylesFromApi();
        },
        immediate: true
      },
    },    
    mounted () {
      this.getStylesFromApi()
    },
    methods: {
      async getStylesFromApi () {
        var self = this
        const currentSession = await this.$Amplify.Auth.currentSession()
        const currentToken = currentSession.getIdToken().getJwtToken()
        this.$http.get(process.env.VUE_APP_API_HOST + '/get-stock-style/' + self.stock  ,{
          headers: {
            'Authorization': currentToken,
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          //console.log(response.data)
          self.styles = response.data
          self.listLoad = false
        }).catch(function () {
          self.errorbar = true
        })
      }
    }
  }
</script>

<style scoped lang="sass">
  .card-width
    width: 200px
</style>